import { useContext } from 'react'

import { ActiveStoreViewContext } from './ActiveStoreViewContext'

/**
 * Returns the active store view.
 * @returns The active store view
 */
export function useActiveStoreView() {
  const context = useContext(ActiveStoreViewContext)

  if (!context) {
    throw new Error('No active store view available, is the context missing?')
  }

  return context
}
